"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bottomImageUrlAtom = exports.mainImageCoverAtom = exports.productSheetRenderedAtom = exports.productUrlAtom = exports.productAtom = exports.modalOpenAtom = void 0;
var jotai_1 = require("jotai");
exports.modalOpenAtom = (0, jotai_1.atom)(false);
exports.productAtom = (0, jotai_1.atom)(null);
exports.productUrlAtom = (0, jotai_1.atom)(undefined);
exports.productSheetRenderedAtom = (0, jotai_1.atom)(false);
exports.mainImageCoverAtom = (0, jotai_1.atom)(undefined);
exports.bottomImageUrlAtom = (0, jotai_1.atom)(undefined);
